var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_8337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 6.41211H14.7559V11.9996H23.9996V6.41211Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 12H14.7559V17.5875H23.9996V12Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7562 6.41211H5.53125V11.9996H14.7562V6.41211Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.757 17.5875V12H5.55078V17.5875V18.3937V22.0687C5.55078 22.6687 6.03828 23.1562 6.63828 23.1562H22.8945C23.4945 23.1562 23.982 22.6687 23.982 22.0687V17.5875H14.757Z",
    fill: "#185B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 0.84375H14.7383V6.43125H24.0008V1.93125C23.982 1.33125 23.4945 0.84375 22.8945 0.84375Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559 0.84375H6.65586C6.05586 0.84375 5.56836 1.33125 5.56836 1.93125V6.4125H14.7746V0.84375H14.7559Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.157 18.0938H1.21953C0.563281 18.0938 0.0195312 17.55 0.0195312 16.8937V7.10625C0.0195312 6.45 0.563281 5.90625 1.21953 5.90625H11.157C11.8133 5.90625 12.357 6.45 12.357 7.10625V16.8937C12.357 17.55 11.832 18.0938 11.157 18.0938Z",
    fill: "#17864C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59492 15.45L6.86367 14.1188C6.56367 13.5938 6.37617 13.2375 6.16992 12.8438H6.15117C5.98242 13.2375 5.81367 13.5938 5.53242 14.1188L4.87617 15.45H3.45117L5.47617 12.0563L3.50742 8.71875H4.95117L5.68242 10.1063C5.90742 10.5188 6.07617 10.8563 6.24492 11.2313H6.28242C6.46992 10.8188 6.60117 10.5188 6.82617 10.1063L7.55742 8.71875H8.98242L6.97617 12L9.05742 15.45H7.59492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.5055 6.99414C12.5055 7.03164 12.5055 7.06914 12.5055 7.10664V16.8941C12.5055 17.5504 11.9617 18.0941 11.3055 18.0941H5.69922V19.1629H12.2992C12.9555 19.1629 13.4992 18.6191 13.4992 17.9629V8.17539C13.518 7.57539 13.068 7.06914 12.5055 6.99414Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_8337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.7d6ffcf7c354354166019a98092ff484.svg";
export { ForwardRef as ReactComponent };